export var ValidatorOption = /* @__PURE__ */ ((ValidatorOption2) => {
  ValidatorOption2["YUP"] = "yup";
  ValidatorOption2["ZOD"] = "zod";
  return ValidatorOption2;
})(ValidatorOption || {});
export var Case = /* @__PURE__ */ ((Case2) => {
  Case2[Case2["CAMEL"] = 0] = "CAMEL";
  Case2[Case2["SNAKE"] = 1] = "SNAKE";
  return Case2;
})(Case || {});
export var HTTPMethod = /* @__PURE__ */ ((HTTPMethod2) => {
  HTTPMethod2["HEAD"] = "head";
  HTTPMethod2["GET"] = "get";
  HTTPMethod2["POST"] = "post";
  HTTPMethod2["PUT"] = "put";
  HTTPMethod2["PATCH"] = "patch";
  HTTPMethod2["DELETE"] = "delete";
  HTTPMethod2["CONNECT"] = "connect";
  HTTPMethod2["OPTIONS"] = "options";
  HTTPMethod2["TRACE"] = "trace";
  return HTTPMethod2;
})(HTTPMethod || {});
export var HTTPError = /* @__PURE__ */ ((HTTPError2) => {
  HTTPError2["AbortError"] = "AbortError";
  return HTTPError2;
})(HTTPError || {});
export class FetchError extends Error {
  name = "FetchError";
  context;
  body;
  from(context, body) {
    this.context = context;
    this.body = body;
    return this;
  }
  with(error) {
    if (error) {
      this.name = error.name;
      this.stack = error.stack;
    }
    return this;
  }
}
export class RequestError extends FetchError {
  name = "RequestError";
}
export class ResponseError extends FetchError {
  name = "ResponseError";
}
